export function isNetworkUploadError(err) {
  const msg = String((err && err.message) || err || "");
  return /failed to fetch|networkerror|load failed|network request failed|too large|entity too large|\b413\b/i.test(
    msg
  );
}

function isCompressibleImage(file) {
  const type = String(file.type || "").toLowerCase();
  const name = String(file.name || "").toLowerCase();
  if (type.includes("heic") || type.includes("heif") || type.includes("pdf")) {
    return false;
  }
  if (name.endsWith(".heic") || name.endsWith(".heif") || name.endsWith(".pdf")) {
    return false;
  }
  return type.startsWith("image/") || /\.(jpe?g|png|webp)$/i.test(name);
}

function canvasToJpeg(canvas, quality) {
  return new Promise((resolve) => {
    canvas.toBlob((blob) => resolve(blob), "image/jpeg", quality);
  });
}

export async function compressDocumentImage(file, maxBytes = 900 * 1024) {
  if (!isCompressibleImage(file)) return file;

  const bitmap = await createImageBitmap(file);
  const maxSide = 2200;
  const scale = Math.min(1, maxSide / Math.max(bitmap.width, bitmap.height));
  const width = Math.max(1, Math.round(bitmap.width * scale));
  const height = Math.max(1, Math.round(bitmap.height * scale));
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  if (!ctx) {
    bitmap.close();
    return file;
  }
  ctx.drawImage(bitmap, 0, 0, width, height);
  bitmap.close();

  let quality = 0.84;
  let blob = null;
  for (let i = 0; i < 6; i += 1) {
    blob = await canvasToJpeg(canvas, quality);
    if (blob && blob.size <= maxBytes) break;
    quality -= 0.12;
  }
  if (!blob) return file;

  const baseName = file.name.replace(/\.[^.]+$/, "") || "document";
  return new File([blob], `${baseName}.jpg`, { type: "image/jpeg" });
}



// WEBPACK FOOTER //
// ./src/utils/compressDocumentImage.js